import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import Auth0Provider from '../../core/auth0';
import { tokenRenewed as tokenRenewedAction, tokenRetrieved as tokenRetrievedAction } from '../../store/auth.actions';
import { ImpersonationIndicator } from '../ImpersonationIndicator';
import { SessionExpiredModal } from '../SessionExpiredModal';
import { ImpersonateExpiredModal } from '../ImpersonateExpiredModal';
import AuthPortal from './AuthPortal';
const AuthWrapper = (props) => {
    const { onLoginDone, config, LoadingComponent, children } = props;
    return (React.createElement(Auth0Provider, { onLoginDone: onLoginDone, config: config },
        React.createElement(ImpersonationIndicator, null),
        React.createElement(AuthPortal, { LoadingComponent: LoadingComponent }, children),
        React.createElement(SessionExpiredModal, null),
        React.createElement(ImpersonateExpiredModal, null)));
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    tokenRetrieved: tokenRetrievedAction,
    tokenRenewed: tokenRenewedAction,
}, dispatch);
export default compose(connect(null, mapDispatchToProps), withHandlers({
    onLoginDone: ({ tokenRetrieved, tokenRenewed, onTokenReceived }) => (authProps, isRenewed) => {
        if (onTokenReceived) {
            onTokenReceived({
                token: authProps.token,
                impersonationToken: authProps.impersonationToken,
            });
        }
        if (isRenewed) {
            tokenRenewed(authProps);
        }
        else {
            tokenRetrieved(authProps);
        }
    },
}))(AuthWrapper);
//# sourceMappingURL=AuthPortalContainer.js.map